var _circle, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTool3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3054_8113)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99967,
    cy: 10.5019,
    r: 9.16667,
    fill: "#B9D6DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3054_8113",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 16,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10892 7.08697L16.2356 3.47512C16.7377 3.25197 17.2507 3.765 17.0275 4.26709L13.4157 12.3937C13.1141 13.0724 12.5714 13.6151 11.8927 13.9168L3.76602 17.5286C3.26394 17.7518 2.7509 17.2387 2.97405 16.7366L6.5859 8.60999C6.88754 7.93129 7.43022 7.38861 8.10892 7.08697Z",
    fill: "#FF4A4A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3054_8113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.33983 18.1621L12.9464 13.4481L7.05388 7.5555L2.33983 18.1621Z",
    fill: "#8CBBC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6611 2.84154L12.9471 13.4481L7.05452 7.55559L17.6611 2.84154Z",
    fill: "#62A1B3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3054_8113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.501953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool3);
export default __webpack_public_path__ + "static/media/tool_3.1b94ee156a9a058aabb23fd0960b4fd7.svg";
export { ForwardRef as ReactComponent };